import { IWprControlProps } from '../props/IWprControlProps';
import { WprControlInfo } from '../../view/control/WprControlInfo';
import { WprBaseControlComponent } from './WprBaseControlComponent';
import { WprActionInfo } from '../../action/WprActionInfo';

/**
 * コントロール基本コンポーネント
 */
export abstract class WprBaseInputControlComponent<T extends IWprControlProps, U> extends WprBaseControlComponent<T, U> {
	// private 変数  ------------------------------------------------------------
	private m_ActionInfo: WprActionInfo		= null;		// アクション情報
	// --------------------------------------------------------------------------

	// コンストラクタ  -----------------------------------------------------------
	constructor(props: T) {
		super(props);
		this.m_ActionInfo = this.props.view.getBlurActionInfo(this.props.name);
		if (this.m_ActionInfo != null)
			this.setBlureEvent(this.onBlur.bind(this));
	}
	// --------------------------------------------------------------------------

	// イベント  ----------------------------------------------------------------
	/**
	 * ロストフォーカス処理
	 * @param event ロストフォーカスイベント
	 */
	public onBlur(event: React.ChangeEvent<U>): void {
		if (this.props.row)
			this.m_ActionInfo.execute(event, this.props.row);
		else
			this.m_ActionInfo.execute(event);
	}
	// --------------------------------------------------------------------------
}